import { SourceType } from '$/utils/upload';

export type RenderMarkOrderNode = (order: number) => React.ReactNode;
export interface MarkOrderConfig {
  className?: string;
}

export interface MarkResult {
  name: string;
  box?: { x: number; y: number; w: number; h: number; };
  objectType?: number;
}

export enum InlineBoxType {
  Mark = 'mark',
  Image = 'image',
  Video = 'video',
  File = 'file',
  Skill = 'skill',
  Role = 'role',
  Text = 'text',
}

export interface IInlineBoxData {
  layerId?: string;
  url: string;
  name: string;
  /** 可选缩略图/图标，完整 URL 渲染图片，否则作为 IconFont 名称渲染 */
  icon?: string;
  /** Hover 时是否展示预览弹框，默认 true */
  showHoverPopover?: boolean;
  index: string;
  order?: number;
  point?: {
    x: number;
    y: number;
  };
  box?: {
    x: number;
    y: number;
    w: number;
    h: number;
  };
  width?: number;
  height?: number;
  objectType?: number;
  mediaType?: 'image' | 'video' | 'file' | 'skill' | 'input_ip';
  /** IP 业务 ID；IP 资源的 index 仅标识本次资源实例。 */
  ipId?: string;
  source?: SourceType;
  /** 画布引用来源节点 ID，仅用于跨面板联动与埋点。 */
  canvasNodeId?: string;
  coverUrl?: string;
  description?: string;
  size?: number;
  /** 发送消息或历史回填时绑定的资产库 id，供拖入画布时直接透传 */
  asset_id?: number;
  /** Mark 插入时是否展示序号角标，默认 true */
  showOrder?: boolean;
  tag?: string; // 约束匹配字段及[@tag:xxx]中的tag值，特殊类型如Mark可直接指定tag为camera_movement等以兼容历史数据
  compressUrl?: string; // 压缩后的图片地址，主要用于 Mark 插入时的预览图
  watermarkCompressUrl?: string; // 带水印的压缩图片地址，主要用于 Mark 插入时的预览图
}

export interface InlineBoxDragPayload {
  type: 'image' | 'video';
  url: string;
  uri: string;
  coverUrl?: string;
  suffix?: string;
  taskId?: string;
  insertPos: 'point';
  extraData?: Record<string, unknown>;
}
export enum InlineBoxUpdateType {
  Name = 'inlineBoxName',
  Order = 'inlineMarkOrder',
  Loading = 'inlineBoxNameLoading',
  Selected = 'inlineBoxCardSelected',
}

export interface IInlineBoxConfig {
  [InlineBoxUpdateType.Loading]?: boolean;
  [InlineBoxUpdateType.Selected]?: boolean;

}

export interface IInlineBox {
  type: InlineBoxType;
  data: IInlineBoxData;
}
export interface ImageInlineBox extends IInlineBox {
  type: InlineBoxType.Image;
}
export interface VideoInlineBox extends IInlineBox {
  type: InlineBoxType.Video;
}
export interface DocumentInlineBox extends IInlineBox {
  type: InlineBoxType.File;
}
export interface MarkInlineBox extends IInlineBox {
  type: InlineBoxType.Mark;
}
